import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

const ADMIN_EMAILS = [
  "rendall.smth@gmail.com",
  "theimmortal.ytcontact@gmail.com",
  "kndzcloud@gmail.com"
,];

export function useAccess(user, authLoading) {
  const [accessStatus, setAccessStatus] = useState('loading');

  useEffect(() => {
    // Attendre que Firebase Auth soit prêt
    if (authLoading) return;

    if (!user) {
      setAccessStatus('none');
      return;
    }

    // Vérification admin
    if (ADMIN_EMAILS.includes(user.email?.toLowerCase())) {
      setAccessStatus('admin');
      return;
    }

    // Vérification Patreon
    const checkPatreon = async () => {
      try {
        const ref = doc(db, 'users', user.uid);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          const status = data?.patreonStatus;
          if (status?.active === true) {
            setAccessStatus('active');
          } else {
            setAccessStatus('inactive');
          }
        } else {
          setAccessStatus('inactive');
        }
      } catch (err) {
        console.error('useAccess error:', err);
        setAccessStatus('inactive');
      }
    };

    checkPatreon();
  }, [user, authLoading]);

  return accessStatus;
}